import { render, staticRenderFns } from "./FaqCategory.vue?vue&type=template&id=7065aa40&scoped=true"
import script from "./FaqCategory.vue?vue&type=script&lang=js"
export * from "./FaqCategory.vue?vue&type=script&lang=js"
import style0 from "./FaqCategory.vue?vue&type=style&index=0&id=7065aa40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7065aa40",
  null
  
)

export default component.exports